import React from "react";
import { Link as RouterLink } from "react-router-dom";
import { Box, Link, Typography } from "@mui/material";
import logo from "../Assets/Images/lifestack-logo.png";

const FOOTER_LINKS = [
  { label: "Help", to: "/help" },
  { label: "Privacy", to: "/privacy" },
  { label: "Terms", to: "/terms" },
];

export default function AppFooter({ sx }) {
  const year = new Date().getFullYear();

  return (
    <Box
      component="footer"
      sx={{
        mt: "auto",
        pt: { xs: 2.25, sm: 2.75 },
        pb: { xs: 2.5, sm: 3.25 },
        px: { xs: 2, sm: 3 },
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: 1.15,
        borderTop: "1px solid rgba(255,255,255,0.1)",
        ...sx,
      }}
    >
      <Box
        component={RouterLink}
        to="/"
        aria-label="Lifestack home"
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 0.9,
          textDecoration: "none",
          color: "inherit",
          "&:hover .footer-wordmark": { color: "rgba(255,255,255,0.88)" },
        }}
      >
        <Box
          component="img"
          src={logo}
          alt=""
          sx={{ height: 20, width: "auto", display: "block" }}
        />
        <Typography
          className="footer-wordmark"
          sx={{
            fontWeight: 700,
            fontSize: "0.72rem",
            letterSpacing: "0.18em",
            textTransform: "uppercase",
            color: "rgba(255,255,255,0.62)",
            transition: "color 160ms ease",
          }}
        >
          Lifestack
        </Typography>
      </Box>

      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexWrap: "wrap",
          columnGap: 1.15,
          rowGap: 0.35,
        }}
      >
        {FOOTER_LINKS.map((item, index) => (
          <React.Fragment key={item.to}>
            {index > 0 ? (
              <Box
                component="span"
                aria-hidden
                sx={{ color: "rgba(255,255,255,0.2)", fontSize: "0.7rem", lineHeight: 1 }}
              >
                ·
              </Box>
            ) : null}
            <Link
              component={RouterLink}
              to={item.to}
              underline="none"
              sx={{
                color: "rgba(255,255,255,0.48)",
                fontSize: "0.75rem",
                fontWeight: 600,
                letterSpacing: "0.04em",
                "&:hover": { color: "rgba(255,255,255,0.88)" },
              }}
            >
              {item.label}
            </Link>
          </React.Fragment>
        ))}
      </Box>

      <Typography
        sx={{
          color: "rgba(255,255,255,0.32)",
          fontSize: "0.68rem",
          letterSpacing: "0.08em",
        }}
      >
        © {year} Lifestack
      </Typography>
    </Box>
  );
}
